<nav class="navbar navbar-top fixed-top max-width safe-area-top">
  <a appHrefNone class="navbar-top-icon-back" (click)="goBack()">
    <span class="d-inline-block">
        <span class="icon-v2 arrow-back-white scale-82"></span>
    </span>
  </a>

  <div class="visibility-hidden"></div>
</nav>
